import AituDisciplinePage from "./AituDisciplinePage";

export default AituDisciplinePage;